import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { singleton, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (_arg_1) => (new PageHeader(1, ["Anstehende Verrechnungen"])), (_arg_3) => (!isEmpty(_arg_3) ? ((head(_arg_3) === "verrechnungen") ? (isEmpty(tail(_arg_3)) ? (new Page(undefined)) : undefined) : undefined) : undefined), (_arg_2) => singleton("verrechnungen"), (_arg) => {
    if (_arg.tag === 18) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
